/*
================================================================================
FILE HEADER — apps/studio-web/src/components/ConnectionDoctor.tsx
================================================================================

CHANGE LOG
----------
| #  | Date       | Who               | Why               | What Changed               |
|----|------------|-------------------|-------------------|----------------------------|
| 1  | 2026-06-23 | Claude Sonnet 4.6 | Phase 0 bootstrap | Created connection doctor  |
| 2  | 2026-11-05 | Claude Opus 5.5   | Public hosting + rename | Visible name Plex → Scriptwave; hosted at scriptwave.qagreen.com |

FILES THAT IMPORT THIS FILE
-----------------------------
- apps/studio-web/src/App.tsx

EXPORTS COVERED
---------------
- ConnectionDoctor — shown when the extension is not found or can't connect
================================================================================
*/

type Props = {
  onRetry: () => void;
};

export function ConnectionDoctor({ onRetry }: Props) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      flex: 1,
      gap: 16,
      padding: 32,
      color: '#a1a1aa',
    }}>
      <div style={{ fontSize: 40 }}>🔌</div>
      <h2 style={{ fontSize: 18, fontWeight: 600, color: '#e4e4e7', margin: 0 }}>
        Scriptwave Extension Not Found
      </h2>
      <p style={{ fontSize: 13, maxWidth: 420, textAlign: 'center', lineHeight: 1.6, margin: 0 }}>
        Scriptwave Studio needs the Scriptwave Web Recorder extension to capture clicks and record ARIA selectors.
      </p>
      <ol style={{ fontSize: 13, maxWidth: 380, lineHeight: 2, textAlign: 'left', paddingLeft: 20 }}>
        <li>Load the extension from <code style={codeStyle}>apps/plex-extension/dist</code> in Chrome</li>
        <li>Go to <code style={codeStyle}>chrome://extensions</code> → enable Developer mode → Load unpacked</li>
        <li>Pin the Scriptwave extension to your toolbar</li>
        <li>Click "Retry" below</li>
      </ol>
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          onClick={onRetry}
          style={{
            background: '#7c3aed',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            padding: '8px 18px',
            fontSize: 13,
            cursor: 'pointer',
            fontWeight: 500,
          }}
        >
          Retry Connection
        </button>
      </div>
    </div>
  );
}

const codeStyle: React.CSSProperties = {
  background: '#1c1c1f',
  border: '1px solid #3f3f46',
  borderRadius: 3,
  padding: '1px 5px',
  fontFamily: 'monospace',
  fontSize: 12,
  color: '#a78bfa',
};
